import React, { useState, useEffect } from "react";
import API from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Button,
    Container,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    useTheme
} from "@mui/material";

interface Report {
    reportID: string;
    name: string;
    description: string;
    isActive: boolean;
    createdAt: string;
    updatedAt?: string;
}

const ReportsPage: React.FC = () => {
    const [reports, setReports] = useState<Report[]>([]);
    const navigate = useNavigate();
    const theme = useTheme();

    useEffect(() => {
        fetchReports();
    }, []);

    const fetchReports = async () => {
        try {
            //const response = await API.get<Report[]>("/reports");
            //setReports(response.data);
        } catch (error) {
            console.error("Error fetching reports:", error);
        }
    };

    const deleteReport = async (reportID: string) => {
        if (window.confirm("Are you sure you want to delete this report?")) {
            try {
                await API.delete(`/reports/${reportID}`);
                setReports((prev) => prev.filter((r) => r.reportID !== reportID));
            } catch (error) {
                console.error("Error deleting report:", error);
            }
        }
    };

    return (
        <Box
            sx={{
                padding: 3,
                backgroundColor: theme.palette.background.default,
                color: theme.palette.text.primary,
                minHeight: "100vh"
            }}
        >
            <Container maxWidth="lg">
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                    <Typography variant="h5">Reports</Typography>
                    <Button variant="contained" color="primary" onClick={() => navigate("/reports/new")}>
                        + Create New Report
                    </Button>
                </Box>

                <Paper elevation={3}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell align="center">Active</TableCell>
                                    <TableCell>Created At</TableCell>
                                    <TableCell align="right">Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {reports.map((report) => (
                                    <TableRow key={report.reportID}>
                                        <TableCell>{report.name}</TableCell>
                                        <TableCell>{report.description}</TableCell>
                                        <TableCell align="center">
                                            {report.isActive ? "✅" : "❌"}
                                        </TableCell>
                                        <TableCell>{new Date(report.createdAt).toLocaleString()}</TableCell>
                                        <TableCell align="right">
                                            <Box display="flex" justifyContent="flex-end" gap={1}>
                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    onClick={() => navigate(`/reports/edit/${report.reportID}`)}
                                                >
                                                    Edit
                                                </Button>
                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    color="error"
                                                    onClick={() => deleteReport(report.reportID)}
                                                >
                                                    Delete
                                                </Button>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Container>
        </Box>
    );
};

export default ReportsPage;
